class Tabs {
	constructor(element) {
		this.container = element;
		this.tabs = [...this.container.querySelectorAll('[role="tab"]')];
		this.panels = [...this.container.querySelectorAll('[role="tabpanel"]')];
		this.id = window.location.href;
		this.lastTab = localStorage.getItem(`${this.id}_tab`) || 0;
		this.current = null;
		this.currentPanel = null;

		this.tabs.forEach((tab, index) => {
			if (window.location.hash === tab.getAttribute("href")) {
				this.lastTab = index;
				history.replaceState({}, document.title, window.location.href.split('#')[0]);
			}
			tab.addEventListener("click", (event) => {
				event.preventDefault();
				this.open(index);
			});
		});

		this.open(this.lastTab);
	}

	open(index) {
		if (this.current !== null) {
			this.tabs[this.current].classList.remove("current");
			this.panels[this.current].classList.remove("current");
		}

		this.current = index;

		this.tabs[this.current].classList.add("current");
		this.panels[this.current].classList.add("current");

		localStorage.setItem(`${this.id}_tab`, index);
	}
}
